"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPresenceIdx = void 0;
/** Indices into the {@link UserPresence} tuple. */
var UserPresenceIdx;
(function (UserPresenceIdx) {
    UserPresenceIdx[UserPresenceIdx["UserId"] = 0] = "UserId";
    UserPresenceIdx[UserPresenceIdx["ProcessId"] = 1] = "ProcessId";
    UserPresenceIdx[UserPresenceIdx["Seq"] = 2] = "Seq";
    UserPresenceIdx[UserPresenceIdx["Ts"] = 3] = "Ts";
    UserPresenceIdx[UserPresenceIdx["Selections"] = 4] = "Selections";
    UserPresenceIdx[UserPresenceIdx["Meta"] = 5] = "Meta";
})(UserPresenceIdx || (exports.UserPresenceIdx = UserPresenceIdx = {}));
